import React from "react";
import { Colors } from "@blueprintjs/core";
import styled from "styled-components";
import Lorem from "react-lorem-component";
import * as Base from "./TinyLayout";

const Wrapper = Base.Wrapper.extend`
  background-color: hsla(0, 0%, 0%, 0.1);
`;

const Banner = Base.Banner.extend`
  min-height: 5em;
  background-color: hsla(0, 0%, 0%, 0.1);
`;

const Navbar = Base.Navbar.extend`
  color: white;
  background-color: hsla(0, 0%, 0%, 0.67);
  padding: 1em;
  line-height: 1;
  & a {
    color: white;
    padding: 0 1rem;
  }
`;

const Columns = Base.Columns.extend`
  _background: hsla(0, 0%, 0%, 0.1);
`;

const Map = Base.Map.extend`
  border: 3px solid;
  background-color: hsla(200, 60%, 60%, 1);
  padding: 1em;
`;

const Tabs = Base.Tabs.extend`
  background: ${Colors.BLUE3};
  height: 50px;
`;

const Content = styled.div`
  padding: 1em 2em;
  & > .controls {
    text-align: right;
    margin-bottom: 1em;
    font-size: large;
  }
`;

const DynamicContent = props => {
  const { count, inc, dec, title } = props;
  return (
    <Content>
      <div className="controls">
        <a onClick={inc}>[+]</a> <a onClick={dec}>[-]</a>
      </div>
      {title && <h2>{title}</h2>}
      {count > 0 && <Lorem count={count} />}
    </Content>
  );
};

class Layout extends React.Component {
  state = {
    banner: false,
    map: false,
    sidebar: false,
    footer: true,
    count: {
      banner: 0,
      main: 4,
      sidebar: 2,
      footer: 2
    }
  };

  toggle(name) {
    this.setState({ [name]: !this.state[name] });
  }

  inc(name) {
    const { count } = this.state;
    this.setState({
      count: { ...count, [name]: count[name] + 2 }
    });
  }

  dec(name) {
    const { count } = this.state;
    this.setState({
      count: {
        ...count,
        [name]: Math.max(count[name] - 2, 0)
      }
    });
  }

  render() {
    const { banner, map, sidebar, count } = this.state;
    return (
      <Wrapper>
        {banner && (
          <Banner>
            <DynamicContent
              title="Banner"
              count={count.banner}
              inc={() => this.inc("banner")}
              dec={() => this.dec("banner")}
            />
          </Banner>
        )}
        <Navbar>
          <a onClick={() => this.toggle("banner")}>Banner</a>
          {" | "}
          <a onClick={() => this.toggle("map")}>Map</a>
          {" | "}
          <a onClick={() => this.toggle("sidebar")}>Sidebar</a>
        </Navbar>
        <Base.Breadcrumbs>Breadcrumbs</Base.Breadcrumbs>
        <Tabs>Tabs</Tabs>
        <div className="sub-wrapper">
          <Columns
            className={sidebar && "sidebar-open"}
            component="div"
            transitionName="example"
            transitionEnterTimeout={Base.animationDuration}
            transitionLeaveTimeout={Base.animationDuration}
          >
            {sidebar ? (
              <Base.Sidebar key="k1">
                <DynamicContent
                  title="Sidebar"
                  count={count.sidebar}
                  inc={() => this.inc("sidebar")}
                  dec={() => this.dec("sidebar")}
                />
              </Base.Sidebar>
            ) : (
              <Base.Main key="k2">
                {map ? (
                  <Map>This is a map.</Map>
                ) : (
                  <DynamicContent
                    title="Content"
                    count={count.main}
                    inc={() => this.inc("main")}
                    dec={() => this.dec("main")}
                  />
                )}
              </Base.Main>
            )}
          </Columns>
        </div>
        <Base.Buttons>Buttons</Base.Buttons>
      </Wrapper>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/app/layout/MobileTest.js